export default __webpack_public_path__ + "static/media/bg.74ad7ea3.svg";